import React from "react";
import type { SliceComponentProps } from "@prismicio/react";
import { PrismicImage } from "@prismicio/react";
import type { UspBarImageAndTextSlice } from "~/lib/prismic/types.generated";
import { asText } from "@prismicio/helpers";
import classNames from "classnames";

const UspBarImageAndText = ({
  slice,
}: SliceComponentProps<UspBarImageAndTextSlice>) => {
  return (
    <div className="uspsbar-container mb-4">
      <div className="alt-uspsbar d-flex flex-nowrap">
        {slice.items &&
          slice.items.map((item, index) => (
            <div
              key={asText(item.text) + index}
              className={classNames(
                "w-100 py-3 pl-3 uspsbar__usp d-flex justify-content-center align-items-center",
                index >= 3 ? "d-md-none" : ""
              )}
            >
              <div className="d-flex">
                <div className="col-auto d-flex align-items-center">
                  <PrismicImage
                    field={item.image}
                    loading="lazy"
                    width={24}
                    height={24}
                    className="uspbar-icon"
                  />
                </div>
                <div className="col d-flex flex-column justify-content-center text-center">
                  {asText(item.text)}
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default UspBarImageAndText;
